import Vue from 'vue';
import Component from './order-confirm-back-dialog';

const ComponentClass = Vue.extend(Component);


export default {
  show(options = {}) {
    return new Promise((resolve, reject) => {
      this.instance = new ComponentClass({
        el: document.createElement('div'),
        data: {
          visible: true,
          date: options.date,
          resolve,
          reject,
        },
      });

      document.body.appendChild(this.instance.$el);

    });
  },
  hide() {
    if (this.instance) {
      document.body.removeChild(this.instance.$el);
      this.instance = null;
    }
  },
};



// WEBPACK FOOTER //
// ./src/pages/ordering/components/order-confirm-back-dialog/index.js